module.exports = __webpack_public_path__ + "img/navigation-pointer-off-02.b8e91a43.svg";